/* The EDGE dealer pilot page (/pages/dealer-pilot): behaviour for sections edge-r-pilot-*.liquid (Lane 21, R2, 2026-10-10).
   From Lane 9's page mock (Round 5). Several sections load this file; it runs once.
   - repair-order math (opens on the locked sentence; floor(RO / 23), spelled out up to twenty)
   - "See your logo on one" panel (opens in place), live logo preview (in this browser only), tagline pickers
     (only when the hero section has tagline words), step 2 open / skip / carry from the panel
   - file checks on pick (type, 15 MB); the form section's inline script does the upload and the send
   - sticky bar after the hero buttons, off over the open panel, the form and the footer
   - founder video: YouTube player loads on tap */
(function () {
  'use strict';
  if (window.erpInit) return;
  window.erpInit = true;
  var S = window.erpState = window.erpState || {};
  var $ = function (sel, root) { return (root || document).querySelector(sel); };
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };

  function ready(fn) { if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn); else fn(); }

  ready(function () {
    /* ---------- repair-order math ---------- */
    var WORDS = ['zero', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine', 'ten', 'eleven', 'twelve', 'thirteen', 'fourteen', 'fifteen', 'sixteen', 'seventeen', 'eighteen', 'nineteen', 'twenty'];
    var roIn = $('#erp-ro-in');
    if (roIn) {
      var roOut = $('[data-erp-ro-out]'), nOut = $('[data-erp-n-out]');
      var setRO = function (v, typing) {
        var n = Math.round(Number(v));
        if (!isFinite(n) || n < 25) n = 25;
        if (n > 2300) n = 2300;
        if (!typing) roIn.value = n;
        if (roOut) roOut.textContent = '$' + n.toLocaleString('en-US');
        var k = Math.floor(n / 23);
        if (nOut) nOut.textContent = k <= 20 ? WORDS[k] : String(k);
      };
      roIn.addEventListener('input', function () { if (roIn.value !== '') setRO(roIn.value, true); });
      roIn.addEventListener('change', function () { setRO(roIn.value); });
      $$('[data-erp-ro-step]').forEach(function (b) {
        b.addEventListener('click', function () { setRO((Number(roIn.value) || 250) + Number(b.getAttribute('data-erp-ro-step'))); });
      });
    }

    /* ---------- taglines (hero settings; none = no picker anywhere) ---------- */
    var tagData = { tags: [], own: '' };
    try { var tj = $('#erp-taglines'); if (tj) tagData = JSON.parse(tj.textContent); } catch (e) {}
    var tags = (tagData.tags || []).filter(function (t) { return t && String(t).trim(); });
    S.ownChip = tagData.own || '';
    S.tag = S.tag || ''; S.own = S.own || '';
    if (tags.length) {
      var choices = tags.slice(); if (S.ownChip) choices.push(S.ownChip);
      $$('[data-erp-tag-group]').forEach(function (g) {
        var grp = g.getAttribute('data-erp-tag-group');
        choices.forEach(function (t) {
          var l = document.createElement('label'); l.className = 'erp-chip';
          var inp = document.createElement('input'); inp.type = 'radio'; inp.name = 'erp-tag-' + grp; inp.value = t;
          var sp = document.createElement('span'); sp.textContent = t;
          l.appendChild(inp); l.appendChild(sp); g.appendChild(l);
          inp.addEventListener('change', function () { S.tag = t; sync(); });
        });
      });
      $$('[data-erp-tag-field]').forEach(function (f) { f.hidden = false; });
    } else {
      $$('[data-erp-tag-field]').forEach(function (f) { f.hidden = true; });
    }
    $$('[data-erp-own-input]').forEach(function (inp) {
      inp.addEventListener('input', function () { S.own = inp.value.slice(0, 40); sync(inp); });
    });
    function tagText() {
      if (!S.tag) return '';
      return S.tag === S.ownChip ? S.own : S.tag;
    }

    /* ---------- previews ---------- */
    var logoUrl = '';
    var placeholders = {};
    $$('[data-erp-preview]').forEach(function (fig, i) {
      var box = $('.erp-pv-logo', fig);
      fig.setAttribute('data-erp-pv-i', i);
      placeholders[i] = box ? box.innerHTML : '';
    });
    function sync(except) {
      $$('[data-erp-tag-group] input').forEach(function (r) { r.checked = (r.value === S.tag); });
      $$('[data-erp-own]').forEach(function (o) { o.hidden = !(S.ownChip && S.tag === S.ownChip); });
      $$('[data-erp-own-input]').forEach(function (i) { if (i !== except) i.value = S.own; });
      $$('[data-erp-own-count]').forEach(function (c) { c.textContent = S.own.length + ' / 40'; });
      $$('[data-erp-name="logo"]').forEach(function (n) { n.textContent = S.logo ? S.logo.name : ''; });
      $$('[data-erp-name="storefront"]').forEach(function (n) { n.textContent = S.storefront ? S.storefront.name : ''; });
      $$('[data-erp-preview]').forEach(function (fig) {
        var box = $('.erp-pv-logo', fig), tg = $('.erp-pv-tag', fig);
        if (box) {
          if (logoUrl) {
            box.textContent = '';
            var im = new Image(); im.alt = ''; im.src = logoUrl; box.appendChild(im);
          } else {
            box.innerHTML = placeholders[fig.getAttribute('data-erp-pv-i')] || '';
          }
        }
        if (tg) tg.textContent = tagText();
      });
    }

    /* ---------- file picks: check type and size here; upload + send live in the form section ---------- */
    var MAX = 15 * 1024 * 1024;
    var TYPES = { logo: /^image\/(png|jpeg|webp|svg\+xml)$/, storefront: /^image\/(png|jpeg|webp|heic|heif)$/ };
    var EXTS = { logo: /\.(png|jpe?g|webp|svg)$/i, storefront: /\.(png|jpe?g|webp|heic|heif)$/i };
    function fileOk(kind, f) {
      if (window.erpPilot && window.erpPilot.fileOk) return window.erpPilot.fileOk(kind, f);
      if (!f || !f.size || f.size > MAX) return false;
      return f.type ? TYPES[kind].test(f.type) : EXTS[kind].test(f.name || '');
    }
    function flag(kind, bad) {
      $$('[data-erp-file-msg="' + kind + '"]').forEach(function (m) { m.hidden = !bad; });
      // no approved message yet: the file's own note turns red instead
      if (!$('[data-erp-file-msg="' + kind + '"]')) $$('[data-erp-note="' + kind + '"]').forEach(function (n) { n.classList.toggle('is-bad', bad); });
    }
    $$('[data-erp-file]').forEach(function (inp) {
      inp.addEventListener('change', function () {
        var kind = inp.getAttribute('data-erp-file');
        var f = inp.files && inp.files[0];
        if (!f) return;
        if (!fileOk(kind, f)) {
          inp.value = '';
          S[kind] = null;
          if (kind === 'logo' && logoUrl) { URL.revokeObjectURL(logoUrl); logoUrl = ''; }
          if (kind === 'storefront') { var t0 = $('#erp-store-thumb'); if (t0) t0.hidden = true; }
          flag(kind, true);
          sync();
          return;
        }
        flag(kind, false);
        S[kind] = f;
        // the other input of the same kind lets go of its old file, so only this one is sent
        $$('[data-erp-file="' + kind + '"]').forEach(function (o) { if (o !== inp) o.value = ''; });
        if (kind === 'logo') {
          if (logoUrl) URL.revokeObjectURL(logoUrl);
          logoUrl = /^image\//.test(f.type) ? URL.createObjectURL(f) : '';
        } else {
          var t = $('#erp-store-thumb');
          if (t) {
            if (/^image\/(png|jpeg|webp)$/.test(f.type)) { t.src = URL.createObjectURL(f); t.hidden = false; } else { t.hidden = true; }
          }
        }
        sync();
        if (window.erpPilot && window.erpPilot.fileChosen) window.erpPilot.fileChosen(kind, f);
      });
    });
    sync();

    /* ---------- "See your logo on one": opens in place ---------- */
    var tryBtn = $('#erp-try-btn'), tryPanel = $('#erp-try');
    if (tryBtn && tryPanel) {
      tryBtn.addEventListener('click', function () {
        var open = tryPanel.hidden;
        tryPanel.hidden = !open;
        tryBtn.setAttribute('aria-expanded', String(open));
        if (open) { try { tryPanel.focus({ preventScroll: true }); } catch (e) { tryPanel.focus(); } }
      });
    }

    /* ---------- step 2 toggle, skip, and carry from the panel ---------- */
    var s2Toggle = $('#erp-s2-toggle'), s2Body = $('#erp-s2-body');
    function openS2(open) { if (!s2Body) return; s2Body.hidden = !open; s2Toggle.setAttribute('aria-expanded', String(open)); }
    if (s2Toggle) s2Toggle.addEventListener('click', function () { openS2(s2Body.hidden); });
    var skip = $('#erp-skip');
    if (skip) skip.addEventListener('click', function () { openS2(false); s2Toggle.focus(); });
    $$('[data-erp-carry]').forEach(function (a) { a.addEventListener('click', function () { if (S.logo || S.tag) openS2(true); }); });

    /* ---------- sticky bar ---------- */
    var sticky = $('#erp-sticky');
    if (sticky && 'IntersectionObserver' in window) {
      var heroGone = false, formOn = false, footOn = false, tryOn = false;
      var link = $('a', sticky);
      var upd = function () {
        var on = heroGone && !formOn && !footOn && !tryOn;
        sticky.classList.toggle('is-on', on);
        sticky.setAttribute('aria-hidden', String(!on));
        if (link) link.tabIndex = on ? 0 : -1;
        document.body.classList.toggle('erp-sticky-on', on);
      };
      var watch = function (el, fn) { if (el) new IntersectionObserver(function (es) { es.forEach(fn); upd(); }).observe(el); };
      watch($('#erp-hero-ctas'), function (en) { heroGone = !en.isIntersecting && en.boundingClientRect.top < 0; });
      watch($('#launch-pilot'), function (en) { formOn = en.isIntersecting; });
      watch($('footer.footer') || $('footer'), function (en) { footOn = en.isIntersecting; });
      watch(tryPanel, function (en) { tryOn = en.isIntersecting; });
    }

    /* ---------- founder video: load the player on tap ---------- */
    $$('[data-erp-video]').forEach(function (box) {
      var btn = $('.erp-play', box);
      if (!btn) return;
      btn.addEventListener('click', function () {
        var id = box.getAttribute('data-erp-video');
        var f = document.createElement('iframe');
        f.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(id) + '?autoplay=1&rel=0&modestbranding=1';
        f.title = box.getAttribute('data-erp-video-title') || '';
        f.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture';
        f.allowFullscreen = true;
        box.textContent = '';
        box.appendChild(f);
      });
    });
  });
})();
